import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WidgetService } from 'src/app/services/platform/widget.service';

/** Route path of the widget error page. */
export const WIDGET_ERROR_PATH = 'widget-error';

/**
 * Shown in place of the widget when the `api_key` query parameter is missing or rejected
 * (see widgetApiKeyGuard). Nothing of the app is loaded behind it: no map, no resolvers,
 * no calculation services.
 */
@Component({
  standalone: true,
  selector: 'app-widget-error',
  templateUrl: './widget-error.component.html',
  styleUrls: ['./widget-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetErrorComponent {

  public readonly supportUrl = 'https://gpstuner.com/contact/';

  private readonly widgetService = inject(WidgetService);

  constructor() {
    // The guard blocks MainComponent, so nothing else removes the index.html loading screen
    // or applies the skin the embedding page asked for.
    document.getElementById('loading-screen')?.remove();
    // Deliberately not the widget's light default: the error card reads better dark. Only an
    // explicit skin=light switches it.
    document.body.classList.toggle('lightSkin', this.widgetService.getSkin() === 'light');
    this.widgetService.applyColors();
  }
}
